import api from "../api";

export interface ResponseGenerica<T> {
    datos: T[],
    error?: string
}
export interface ICalificaciones {
    estado: string;
    id: number;
    calificacion: string;
}
export interface IMedidasCorrectivas {
    descripcion: string;
    id: number;
    tipo_id: number;
}
export interface IDepositoResponse {
    id: number | null;
    calificacion_id: number | null;
    calificacion: string | null;
    medida_correctiva_id: number | null;
    medida_correctiva: string | null;
    plazo: string | null;
}
export interface IPostDeposito {
    calificacion_id: number;
    medida_correctiva_id: number | null;
    plazo_implementacion: string | null;
    deposito_id?: number | null;
}
export interface IResponsePostDeposito {
  exito: boolean;
  mensaje?: string;
}


const API_URL_CALIFICACION = `fiscalizacion/calificaciones`;
const API_URL_MEDIDAS_CORRECTIVAS = `fiscalizacion/medidas_correctivas`;
const API_URL_DEPOSITO = `fiscalizacion/deposito`;


export const fetchCalificaciones = async () => {
    try {
      
      const response = await api.get(`${API_URL_CALIFICACION}`);
  
      if (response.data && response.data.datos) {
        return {
          datos: response.data.datos,
        };
      } else {
        return {
          datos: [],
          error: "No se encontraron datos"
        };
      }
    } catch (error) {
      console.error('Error en fetchCalificaciones:', error);
      return {
        datos: [],
        error: "Error al obtener las calificaciones"
      };
    }
  };
  

  export const fetchMedidasCorrectivas = async (): Promise<ResponseGenerica<IMedidasCorrectivas[]>> => {
    try {
      const response = await api.get(`${API_URL_MEDIDAS_CORRECTIVAS}`);
  
      if (response.data && response.data.datos) {
        return {
          datos: response.data.datos
        };
      } else {
        return {
          datos: [],
          error: response.data.error || "No se encontraron medidas correctivas"
        };
      }
    } catch (error) {
      console.error('Error en fetchMedidasCorrectivas:', error);
      return {
        datos: [],
        error: "Error al obtener las medidas correctivas"
      };
    }
  };
  
  

  export const fetchDeposito = async (fiscalizacionId: number): Promise<ResponseGenerica<IDepositoResponse>> => {
    try {
      const response = await api.get(`${API_URL_DEPOSITO}/${fiscalizacionId}`);
  
      if (response.data && response.data.datos) {
        return {
          datos: [response.data.datos]
        };
      } else {
        return {
          datos: [],
          error: response.data.error || "No se encontró información del depósito"
        };
      }
    } catch (error) {
      console.error('Error en fetchDeposito:', error);
      return {
        datos: [],
        error: "Error al obtener información del depósito"
      };
    }
  };
  
  

  export const postDeposito = async (fiscalizacion_id: number , postData: IPostDeposito ): Promise<IResponsePostDeposito> => {
    try {
      const response = await api.post(`${API_URL_DEPOSITO}/${fiscalizacion_id}`, postData);
  
      if (response.data && response.data.exito) {
        return response.data;
      } else {
        return {
          exito: true,
          mensaje: response.data.mensaje ?? "Error al publicar información del depósito"
        };
      }
    } catch (error) {
      console.error('Error en postDeposito:', error);
      return {
        exito: false,
        mensaje: "Error inesperado al publicar información del depósito"
      };
    }
  };
  